import { AutostoreBin, Props as AutostoreBinProps } from "./AutostoreBin";
import { ActivityState } from "./BinState";
import { useBinAnimation } from "./useBinAnimation";

type Props = Omit<AutostoreBinProps, "state"> & {
  /** The port number listen to for animation updates */
  portId: number;
  /** Bypass the current bin state and specify your own */
  stateOverride?: ActivityState;
  /** The port side index for multiport-enabled ports. When only one side of the
   * multiport is used at time, this facilitates showing the other as inactive.
   */
  portSideIndex?: number;
};

export const AutostoreBinWithAnimation = ({
  portId,
  portSideIndex,
  stateOverride,
  ...rest
}: Props) => {
  const { animationCategory, activityState, binsAbove } = useBinAnimation(
    portId,
    portSideIndex
  );

  return (
    <AutostoreBin
      {...rest}
      state={stateOverride || animationCategory || activityState}
      binsAbove={binsAbove}
    />
  );
};
